import { all } from 'redux-saga/effects'
import loginWatcher from './login/sagas'
import userWatcher from './user/sagas'
import { watchEventListRfq } from './filterSourcingEvent/sagas'

export function* rootSaga() {
  yield all([loginWatcher(), userWatcher(), watchEventListRfq()])
}
